const DAY_MS = 24 * 60 * 60 * 1000;

// Dias corridos desde que o produto ficou visível (products.visibleAt) até
// hoje. Conta por data do calendário local: visível hoje = 0, ontem = 1.
// Sem data (ou data inválida) = null.
export function visibleDays(visibleAt, now = new Date()) {
  if (!visibleAt) return null;
  const start = new Date(visibleAt);
  if (isNaN(start.getTime())) return null;
  const startDay = Date.UTC(start.getFullYear(), start.getMonth(), start.getDate());
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.max(0, Math.round((today - startDay) / DAY_MS));
}

export function withVisibleDays(rows, now = new Date()) {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => ({ ...row, visibleDays: visibleDays(row.visibleAt, now) }));
}
